module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-actions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "button-icon lnr-list",
    on: {
      "click": function($event) {
        _vm.goTo('dashboard')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Files')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('realestates-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "building-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Real_estates')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('ads-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "bookmark-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Ads')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('contacts-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "address-card-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Contacts')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalquotes-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-powerpoint-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Quotes')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalinvoices-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eur",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Invoices')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisers-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Appraisers')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('supervisors-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Supervisors')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('entities-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "university",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Entities')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('becproperties-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Construction_prices')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('bdefiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "archive",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('BDE_files')))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "foot__right"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticStyle: {
      "border": "1px solid #DDDDDD",
      "padding": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('Language')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('ca')
      }
    }
  }, [_vm._v("Català")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('es')
      }
    }
  }, [_vm._v("Castellano")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('dropdown')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#1a3856"
    }
  }, [_c('strong', [_vm._v("Bonell+Dòriga")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13af1402!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bar/BarActions.vue
// module id = 2106
// module chunks = 0